<template>
	<div>
		<div v-if="valid">
			<div v-if="working" class="working">
				<p class="text-center">Academy data is being processed. This may take a few minutes.</p>
			</div>

			<div class="pull-right clearfix">

				<div><strong>Last Sync:</strong> {{status.lastSync}}&nbsp;&nbsp;&nbsp;&nbsp;<strong>Status:</strong> {{status.status}}</div>
				<br>
				<div class="text-right">
					<button :disabled="!status.syncAvailable" v-on:click="confirmSync"><i class="fa fa-circle-o-notch" aria-hidden="true"></i> Sync Now</button>&nbsp;&nbsp;&nbsp;
					<router-link tag="button" :to="{ name: 'troubleshooting', params: { acadid: academy.id  }}" :disabled="!status.syncAvailable"><i class="fa fa-address-card"></i> Troubleshoot</router-link>
				</div>
			</div>

			<h1>{{academy.name}}</h1>

			<confirm v-if="confirm.enabled" @cancel="confirm.enabled = false" @confirm="onConfirm">
				<span v-html="confirm.msg" slot="body"></span>
			</confirm>

			<div class="section" v-if="progress.active">
				<h3>Sync Progress</h3>
				<div class="progress">
					<div class="progress-bar progress-bar-success progress-bar-striped active" v-bind:style="{ width: progress.percent + '%'}"></div>
				</div>
				<p class="text-center">{{progress.percent}}% Complete - {{progress.msg}}</p>
			</div>


				<div class="section sync-actions clearfix">
					<h3>Options</h3>

					<div class="toggles">

						<div class="option-group">
							<span class="action-label">HRID sync:</span>
							<Toggle @change="confirmToggleHRID" v-bind:value="hridSync"></Toggle>
						</div>

						<div class="option-group">
							<span class="action-label">ASC user sync:</span>
							<Toggle @change="confirmToggleASC" v-bind:value="ascUserSync"></Toggle>
						</div>

						<div class="option-group">
							<span class="action-label">Push HRIDs to Schoox:</span>
							<Toggle @change="confirmPushHRID" v-bind:value="hridPush"></Toggle>
						</div>



						<div class="delay-options">
							<span class="action-label">Delay removal:</span>
							<Toggle @change="confirmDelayRemove" v-bind:value="delay.action"></Toggle>
							<span>
								<input type="number" :disabled="!delay.action" v-on:blur="saveDelayDays" v-on:keyup.enter="saveDelayDays" class="form-control delay-days" v-model="days" min="delayMin" max="delayMax">
							</span>
						</div>

					</div>


					<div class="ignore-container">
						<div>
							<span class="action-label">HotSchedules id ignore list:</span>
							<div class="add-ignore-form">
								<input v-model="ignoreToAdd" type="text" class="ignore-input" v-on:keyup.enter="addIgnore"><button v-on:click="addIgnore">Add HotSchedules id</button>
							</div>
						</div>
						<div class="ignores-list">
							<span class="ignore-item" v-for="ignore in ignores">{{ignore}} <i class="fa fa-times" v-on:click="removeIgnore(ignore)"></i></span>
						</div>
					</div>
				</div>

				<hr>

				<div class="section">
					<h3>Pay Type Mappings</h3>

					<div v-if="paytypeJobsReady">
					<pay-config v-bind:hourly="hourly" v-bind:salary="salary" @update="updatePayType"></pay-config>
					</div>
					<div v-else>
						<p>{{paytypeJobsMessage}}</p>
					</div>
				</div>

				<hr>

				<div class="section">
					<h3>Exclude Jobs</h3>
					<div v-if="jobsmapReady">
						<exclude-jobs v-bind:available="syncedJobs" v-bind:excluded="exludedJobs" @update="updateExcludedJobs"></exclude-jobs>
					</div>
					<div v-else>
						<p>{{jobsmapMessage}}</p>
					</div>
				</div>

				<hr>

				<div class="section">
					<h3>Job Name Mappings</h3>

					<div v-if="jobsmapReady">
						<table  class="table table-striped table-bordered config-table">
							<thead>
								<tr>
									<th>Schoox Job Name</th>
									<th>HS Job Names</th>
									<th># Jobs</th>
									<th>
										<button v-on:click="editJobMapping(jobsmap.length)"><i class="fa fa-plus" aria-hidden="true"></i> Add Job Mapping</button>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(row, index) in jobsmap">
									<tr v-if="jobEditor.index === index">
										<td colspan="4">
											<job-config @ready="scroll" v-bind:toName="row.scxJobName" v-bind:hsNames="row.hsNames" v-bind:index="index" v-bind:available="availableJobs" v-bind:restricted="getRestrictedNames(row.scxJobName)" @cancel="cancelJobMapEdit" @finish="finishJobNameEdit"></job-config>
										</td>
									</tr>
									<tr v-else>
										<td>{{row.scxJobName}}</td>
										<td>{{row.hsNames.join(', ')}}</td>
										<td>{{row.hsNames.length}}</td>
										<td>
											<button v-on:click="editJobMapping(index)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button>
											<button v-on:click="confirmJobNameRemove(index)"><i class="fa fa-times" aria-hidden="true"></i> Remove</button>
										</td>
									</tr>

								</template>
								<tr v-if="jobEditor.index === jobsmap.length">
									<td colspan="4">
										<job-config @ready="scroll" v-bind:index="jobsmap.length" v-bind:available="availableJobs" v-bind:restricted="getRestrictedNames()" @cancel="cancelJobMapEdit" @finish="finishJobNameEdit"></job-config>
									</td>
								</tr>
							</tbody>
						</table>
						<p v-if="!jobsmap.length">No Job Name Mappings. Click Add Job Name Mapping to get started.</p>
					</div>
					<div v-else>
						<p>{{jobsmapMessage}}</p>
					</div>


				</div>

				<hr>

				<div class="section">
					<div class="pull-right">
						<router-link tag="button" :to="{ name: 'mapping', params: { acadid: academy.id  }}"><i class="fa fa-map"></i> Add Mapping</router-link>
						<button @click="confirmRemoveAll" ><i class="fa fa-times" aria-hidden="true"></i> Remove All Mappings</button>
					</div>
					<h3>Academy Mappings</h3>
					<v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
				</div>




		</div>

		<div v-else>
			<h2>No Academy found for {{$route.params.id}}</h2>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'underscore'
import store from '../data/AppData'
import Toggle from './Toggle'
import Q from '../vendor/q'
import vueScrollTo from 'vue-scrollTo'
import {router} from '../routes/Router'

Vue.use(vueScrollTo)

const bus = new Vue()

const rowMapper = row => {
	return {
		'extCompRef': row.extCompRef,
		'Mapped Location/Node': row.description,
		'Location/Node ID': row.nodeid,
		'data': row
	}
}

const removeTemplate = (h, row) => {
	return h('remove-mapping', {
		attrs: {
			'row': row.data
		}
	})
}

const troubleshootTemplate = (h, row) => {
	return h('troubleshoot-mapping', {
		attrs: {
			'row': {
				extCompRef: row.data.extCompRef,
				storeId: row.data.nodeid
			}
		}
	})
}

Vue.component('remove-mapping', {
	props: ['row'],
	template: '<button v-on:click="emitRemove"><i class="fa fa-times" aria-hidden="true"></i> Remove</button>',
	methods: {
		emitRemove: function (e) {
			// console.log('remove mapping', this.row)
			bus.$emit('remove', this.row)
			e.preventDefault()
		}
	}
})

Vue.component('troubleshoot-mapping', {
	props: ['row'],
	template: '<button v-on:click="emitTroubleshoot"><i class="fa fa-building-o" aria-hidden="true"></i> Troubleshoot</button>',
	methods: {
		emitTroubleshoot: function (e) {
			// console.log('remove mapping', this.row)
			bus.$emit('troubleshoot', this.row)
			e.preventDefault()
		}
	}
})

export default{
	name: 'AcademyDetails',
	components: {
		'job-config': require('./JobNameMapEditor'),
		'pay-config': require('./PayTypeEditor'),
		'exclude-jobs': require('./excludeJobsEditor'),
		Toggle
	},
	data () {
		return {
			columns: ['Mapped Location/Node', 'Location/Node ID', 'extCompRef', 'Action', 'Troubleshoot'],
			options: {
				perPage: 100,
				filterable: false,
				templates: {
					'Action': removeTemplate,
					'Troubleshoot': troubleshootTemplate
				}
			},
			delayMin: 1,
			delayMax: 60,
			editIgnores: false,
			ignoreToAdd: '',
			confirm: {
				enabled: false,
				action: null,
				msg: null
			},
			progress: {
				percent: 20,
				msg: 'Loading user data from HotSchedules',
				active: false,
				tempStep: 0,
				temp: [
					{ percent: 0, t: 300, msg: 'Loading user data from HotSchedules' },
					{ percent: 15, t: 600, msg: 'some message 1' },
					{ percent: 27, t: 800, msg: 'some message 2' },
					{ percent: 63, t: 700, msg: 'some message 3' },
					{ percent: 90, t: 300, msg: 'some message 4 almost finished' }
				]
			},
			jobEditor: {
				jobs: [],
				name: '',
				index: null
			},
			paytype: {
				editing: false
			}
		}
	},
	computed: {
		valid () {
			let id = parseInt(this.$route.params.id)
			return !_.isUndefined(_.findWhere(this.$store.state.academiesList, { id: id }))
		},
		academy () {
			let id = parseInt(this.$route.params.id)
			return _.findWhere(this.$store.state.academiesList, { id: id })
		},
		tableData () {
			return _.map(this.academy.mappings, rowMapper)
		},
		jobsmap () {
			let js = this.$store.state.config.swapJobs

			// no jobswapping
			if (!js || !js.action) { return [] }

			return this.$store.state.config.swapJobs.jobSwapper.jobsmap
		},
		jobsmapReady () {
			return this.$store.state.jobswap.ready
		},
		jobsmapMessage () {
			return this.$store.state.jobswap.msg
		},
		paytypeJobsReady () {
			return this.$store.state.paytype.ready
		},
		paytypeJobsMessage () {
			return this.$store.state.paytype.msg
		},
		availableJobs () {
			let usedNames = _.chain(this.jobsmap).map((row) => {
				let names = _.clone(row.hsNames)
				names.push(row.scxJobName)
				return names
			}).flatten().value()

			return _.difference(this.$store.state.jobswap.list, usedNames)
		},
		syncedJobs () {
			return _.difference(this.$store.state.jobswap.list, this.$store.state.config.excludeJobs)
		},
		exludedJobs () {
			return this.$store.state.config.excludeJobs
		},
		hridSync () {
			return this.$store.state.config.hridSync
		},
		ascUserSync () {
			return this.$store.state.config.ascSync
		},
		hridPush () {
			return this.$store.state.config.hridPush
		},
		ignores () {
			return this.$store.state.config.ignores
		},
		delay () {
			return this.$store.state.config.delay
		},
		days () {
			return this.$store.state.config.delay.days
		},
		hourly () {
			return this.$store.state.config.hourly
		},
		salary () {
			return _.difference(this.$store.state.paytype.list, this.$store.state.config.hourly)
		},
		status () {
			return this.$store.state.status
		},
		isSyncing () {
			return this.$store.state.status.status === 'Syncing'
		},
		working () {
			return !this.$store.state.jobswap.ready || !this.$store.state.paytype.ready || this.$store.state.status.status === 'Syncing'
		}
	},
	methods: {
		confirmSync () {
			this.toConfirm('Confirm start sync', () => {
				this.syncNow()
			})
		},
		syncNow () {
			this.$store.dispatch('sync', this.$route.params.id)
			this.stopSyncPoll = this.$watch(() => this.$store.state.sync.count, () => this.pollSync())
		},
		// confimation dialogs
		toConfirm (msg, action) {
			this.confirm.action = action
			this.confirm.msg = msg
			this.confirm.enabled = true
		},
		onConfirm () {
			if (this.confirm.action) {
				this.confirm.action()
			}
			this.confirm.enabled = false
		},
		getActionLabel (b) { return b ? 'disable' : 'enable' },
		confirmToggleHRID () {
			this.toConfirm('Confirm ' + this.getActionLabel(this.hridSync) + ' HRID sync', () => {
				this.$store.dispatch('setHRIDsync', {
					id: this.academy.id,
					action: !this.hridSync
				})
			})
		},
		confirmToggleASC () {
			this.toConfirm('Confirm ' + this.getActionLabel(this.ascUserSync) + ' ASC user sync', () => {
				this.$store.dispatch('setASCsync', {
					id: this.academy.id,
					action: !this.ascUserSync
				})
			})
		},
		confirmPushHRID () {
			this.toConfirm('Confirm ' + this.getActionLabel(this.hridPush) + ' Push HRIDs to Schoox', () => {
				this.$store.dispatch('setHRIDpush', {
					id: this.academy.id,
					action: !this.hridPush
				})
			})
		},
		confirmRemoveMapping (toRemove) {
			this.toConfirm('Confirm remove mapping.<br>This action cannot be undone.', () => {
				this.$store.dispatch('removeMapping', {
					acadid: this.academy.id,
					mapping: toRemove
				})
			})
		},
		confirmRemoveAll () {
			this.toConfirm('Confirm remove all mappings for ' + this.academy.name + '<br>This action cannot be undone.', () => {
				this.$store.dispatch('removeAllMappings', {
					acadid: this.academy.id
				})
			})
		},
		confirmDelayRemove () {
			let obj = {
				id: this.academy.id,
				action: !this.delay.action,
				days: this.delay.days
			}
			this.toConfirm('Confirm ' + this.getActionLabel(this.delay.action) + ' delay removal', () => this.$store.dispatch('setDelayRemoval', obj))
		},
		saveDelayDays (e) {
			let n = parseInt(e.target.value)
			if (_.isNumber(n) && n !== this.delay.days) {
				this.$store.dispatch('setDelayRemoval', {
					id: this.academy.id,
					action: this.delay.action,
					days: n
				})
			}
		},
		addIgnore (e) {
			if (_.isEmpty(this.ignoreToAdd)) { return }
			this.$store.dispatch('addIgnores', {
				id: this.academy.id,
				ignores: this.ignoreToAdd.split(/,\s*/)
			})
			this.ignoreToAdd = null
			e.preventDefault()
		},
		removeIgnore (ignore) {
			this.$store.dispatch('removeIgnore', {
				id: this.academy.id,
				ignore: ignore
			})
		},
		editJobMapping (index) {
			if (this.$store.state.jobswap.list === 'performing first calculation') {
				// retry getting jobs if not cacluated
				store.dispatch('getJobsList', parseInt(this.$route.params.id))
			}

			// have to add delay becuase custom validator has to be removed and it throws an error if the new editor is created before the old editor is removed
			if (_.isNumber(this.jobEditor.index)) {
				this.jobEditor.index = null
				_.delay(() => { this.jobEditor.index = index }, 100)
			} else {
				this.jobEditor.index = index
			}
		},
		updatePayType (data) {
			this.$store.dispatch('updatePayType', {
				id: this.academy.id,
				hourly: data
			})
		},
		updateExcludedJobs (data) {
			this.$store.dispatch('updateExcluded', {
				id: this.academy.id,
				excludeJobs: data
			})
		},
		scroll (el) {
			vueScrollTo.scrollTo(el, 300, {
				easing: vueScrollTo.easing['ease-in']
			})
		},
		confirmJobNameRemove (index) {
			this.toConfirm('Confirm remove job name mapping', () => {
				let mappings = JSON.parse(JSON.stringify(this.$store.state.config.swapJobs))

				mappings.jobSwapper.jobsmap.splice(index, 1)

				this.$store.dispatch('updateJobsList', {
					id: this.academy.id,
					mappings: mappings
				})
			})
		},
		getRestrictedNames (allow) {
			return _.chain(this.jobsmap).pluck('scxJobName').without(allow).value()
		},
		finishJobNameEdit (index, row) {
			// get copy of
			let mappings = JSON.parse(JSON.stringify(this.$store.state.config.swapJobs))

			mappings.action = true

			if (!mappings.jobSwapper) {
				mappings.jobSwapper = {
					jobsmap: []
				}
			}
			if (!mappings.jobSwapper.jobsmap[index]) {
				mappings.jobSwapper.jobsmap.push(row)
			} else {
				mappings.jobSwapper.jobsmap.splice(index, 1, row)
			}

			this.$store.dispatch('updateJobsList', {
				id: this.academy.id,
				mappings: mappings
			})
			this.jobEditor.index = null
		},
		cancelJobMapEdit () { this.jobEditor.index = null },
		pollJobsMap () {
			if (this.$store.state.jobswap.ready) {
				this.stopJobsPoll()
			} else {
				this.pollJobsTimer = _.delay(() => store.dispatch('getJobsList', this.$route.params.id), 1000)
			}
		},
		pollPayJobs () {
			if (this.$store.state.paytype.ready) {
				this.stopPayPoll()
			} else {
				this.pollPayTimer = _.delay(() => store.dispatch('getJobPaytypes', this.$route.params.id), 1000)
			}
		},
		pollSync () {
			if (this.$store.state.sync.syncAvailable || _.isUndefined(this.$route.params.id)) {
				this.stopSyncPoll()
			} else {
				this.syncPollTimer = _.delay(() => store.dispatch('getStatus', this.$route.params.id), 1000)
			}
		},
		troubleshoot (row) {
			router.push({
				name: 'troubleshootingloc',
				params: row
			})
		}
	},
	created () {
		bus.$on('remove', this.confirmRemoveMapping)
		bus.$on('troubleshoot', this.troubleshoot)
	},
	beforeRouteEnter (to, from, next) {
		let loads = []
		if (!store.state.academiesLoaded) { loads.push(store.dispatch('getAcademies')) }
		Q.all(loads).then(() => next())
	},
	beforeMount () {
		store.dispatch('getAcademyConfig', this.$route.params.id)
		this.stopSyncPoll = this.$watch(() => this.$store.state.sync.count, () => this.pollSync())
	},
	mounted () {
		// if jobs data is not ready implement polling
		if (!this.$store.state.jobswap.ready) {
			this.stopJobsPoll = this.$watch(() => this.$store.state.jobswap.pollCount, () => this.pollJobsMap())
			this.pollJobsMap()
		}
		if (!this.$store.state.paytype.ready) {
			this.stopPayPoll = this.$watch(() => this.$store.state.paytype.pollCount, () => this.pollPayJobs())
			this.pollPayJobs()
		}

		store.dispatch('getStatus', this.$route.params.id)
	},
	beforeDestroy () {
		clearTimeout(this.pollJobsTimer)
		clearTimeout(this.pollPayTimer)
		clearTimeout(this.syncPollTimer)

		if (_.isFunction(this.stopJobsPoll)) {
			this.stopJobsPoll()
		}
		if (_.isFunction(this.stopPayPoll)) {
			this.stopPayPoll()
		}
		if (_.isFunction(this.stopSyncPoll)) {
			this.stopSyncPoll()
		}

		this.$store.dispatch('clearJobs')
	}
}
</script>

<style>
.section{
	margin-top: 10px;
}
.section h3{
	margin-top: 0;
}
.sync-actions{
	margin-bottom: 20px;
}
.option-group{
	margin-right: 1em;
	width: 360px;
}
.delay-options{
	min-width: 200px;
}
.delay-days{
	display: inline-block;
	vertical-align: top;
	width: 60px;
	padding: 0 5px;
	height: 29px
}
.action-label{
	padding-top: 5px;
	display: inline-block;
	vertical-align: top;
}
.toggles{
	width:400px;
	float:  left;
	border-right: 1px solid #eee;
}
.toggles .action-label{
	width: 180px;
}
.ignore-container{
	margin-left: 430px;
}
.add-ignore-form{
	display: inline-block;
	vertical-align: top;
	margin-left: 30px;
}
.ignores-list{
	margin-top: 1em;
}
.ignore-item {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  color: #858585;
  font-weight: normal;
  font-size: 1.1em;
  padding: 0.2em 0.5em;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}
.section .VuePagination__count{
	display: none;
}
.status-table td{
	padding:  5px 10px;
}
.sync-status{
	text-align: right;
}
.sync-status table td{
	text-align: center;
	padding: 5px;
}
.working{
	background-color: #fff9c4;
	margin: 10px 0;
	padding: 10px;
}
.working p{
	padding: 0;
	margin: 0;
}


</style>


// WEBPACK FOOTER //
// Academy.vue?7f5c5cc6